<script setup lang="ts">
  import { Skeleton } from '@rapoo/element'

  const modeSlots = [0, 1, 2, 3, 4, 5]
</script>

<template>
  <div aria-busy="true">
    <div class="flex gap-2">
      <div v-for="slot in 3" :key="slot" class="p-4 rounded-4xl glass-frosted">
        <Skeleton class="w-59 h-25.5 rounded-xl" animation-type="shimmer" />
      </div>
    </div>
    <div class="p-2 mt-2 flex flex-col gap-2 rounded-4xl glass-frosted">
      <div class="flex gap-2">
        <Skeleton
          v-for="slot in modeSlots"
          :key="slot"
          class="h-21.5 flex-1 rounded-2xl"
          animation-type="shimmer"
        />
      </div>
      <Skeleton class="h-15.5 w-full rounded-2xl" animation-type="shimmer" />
      <Skeleton class="h-32 w-full rounded-2xl" animation-type="shimmer" />
    </div>
  </div>
</template>
